var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CelmodeButton',_vm._b({class:_vm.classNames,on:{"click":function($event){return _vm.emitInput(!_vm.value)}}},'CelmodeButton',_vm.$attrs,false),[_c('span',{staticClass:"label"},[_vm._v(_vm._s(_vm.displayText))])])}
var staticRenderFns = []

export { render, staticRenderFns }